export default "__VITE_ASSET__CIiMSWTj__"